import type { CountryCode } from "libphonenumber-js";
import type { DateTimeFormatOptions } from "luxon";

export const defaultCountryIso2: CountryCode = "AU";

export const transactionsPerPage = 30;
export const transactionsPerPageOptions = [10, 30, 50, 100];

export const defaultDateFormat: DateTimeFormatOptions = { month: "long", day: "numeric", year: "numeric" };
export const defaultDateTimeFormat: DateTimeFormatOptions = {
  month: "long",
  day: "numeric",
  year: "numeric",
  weekday: "long",
  timeZoneName: "shortGeneric",
};
